<template>
	<div v-if="total > 0">
		<div class="float-left" v-if="!noPerPage">
			<div class="btn-group btn-group-sm">
				<button type="button" class="btn btn-outline-primary" :class="{ active: perPage == 10 }" @click.prevent="setPerPage(10)">10</button>
				<button type="button" class="btn btn-outline-primary" :class="{ active: perPage == 20 }" @click.prevent="setPerPage(20)">20</button>
				<button type="button" class="btn btn-outline-primary" :class="{ active: perPage == 50 }" @click.prevent="setPerPage(50)">50</button>
				<button type="button" class="btn btn-outline-primary" :class="{ active: perPage == 100 }" @click.prevent="setPerPage(100)">100</button>
			</div>
		</div>
		<div class="float-right">
			<div class="btn-group btn-group-sm">
				<a class="btn btn-outline-primary" :class="{ disabled: skip == 0 }" href="#" @click.prevent="firstPage()">&laquo;<span class="d-md-none d-lg-inline" v-if="!noLabels"> First</span></a>
				<a class="btn btn-outline-primary" :class="{ disabled: skip == 0 }" href="#" @click.prevent="prevPage()">&lsaquo;<span class="d-md-none d-lg-inline" v-if="!noLabels"> Prev</span></a>
				<a class="btn btn-outline-primary" :class="{ disabled: skip >= total - perPage }" href="#" @click.prevent="nextPage()"><span class="d-md-none d-lg-inline" v-if="!noLabels">Next </span>&rsaquo;</a>
				<a class="btn btn-outline-primary" :class="{ disabled: skip >= total - perPage }" href="#" @click.prevent="lastPage()"><span class="d-md-none d-lg-inline" v-if="!noLabels">Last </span>&raquo;</a>
			</div>
		</div>
		<div class="text-center">
			Displaying {{skip+1}} - {{Math.min(skip+perPage, total)}} from {{total}}
		</div>
		<div class="clearfix"></div>
	</div>
</template>

<script>
export default {
	name: 'Pager',
	props: {
		total: Number,
		perPage: Number,
		skip: Number,
		noPerPage: Boolean,
		noLabels: Boolean,
	},
	methods: {
		setPerPage(p) {
			this.$emit('change', { skip: 0, perPage: p });
		},
		firstPage() {
			this.$emit('change', { skip: 0, perPage: this.perPage });
		},
		prevPage() {
			this.$emit('change', { skip: Math.max(this.skip - this.perPage, 0), perPage: this.perPage });
		},
		nextPage() {
			this.$emit('change', { skip: Math.min(this.skip + this.perPage, this.total - 1), perPage: this.perPage });
		},
		lastPage() {
			this.$emit('change', { skip: Math.floor((this.total - 1) / this.perPage) * this.perPage, perPage: this.perPage });
		}
	}
};
</script>
